import React from 'react'
import Img from 'gatsby-image'

const MainImage = ({ mainImage }) => {
  return (
    <section className="main-image">
      <div className="img-div">
        <Img fluid={mainImage.asset.fluid} alt={mainImage.alt} />{' '}
      </div>
      <p className="main-image-caption">{mainImage.caption}</p>
    </section>
  )
}

export default MainImage
